"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PaginationNextButton = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("../Button");
var PaginationContext_1 = require("./PaginationContext");
var PaginationNextButton = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var _b = PaginationContext_1.usePaginationContext(), changePage = _b.changePage, page = _b.page, pageMax = _b.pageMax;
    return (react_1["default"].createElement(Button_1.Button, __assign({ className: ['pagination_next-button', className], disabled: page >= pageMax, onClick: function () {
            changePage(page + 1);
        } }, rest)));
};
exports.PaginationNextButton = PaginationNextButton;
//# sourceMappingURL=PaginationNextButton.js.map